<template>
  <div id="page-wrapper">
    <ItemsPopover :list="showingAutoEndedShifts" />
    <UserProductsModal
      v-if="openedModals.userProducts.isVisible"
      :user-id="openedModals.userProducts.userId"
      :dates="dates"
      @close="toggleUserProductsModal()"
    />
    <UserProjectsModal
      v-if="openedModals.projects.isVisible"
      :projects="openedModals.projects.list"
      :with-failed-deadlines="openedModals.projects.withFailedDeadlines"
      @close="toggleProjectsModal()"
    />
    <div class="prev-page-button__wrapper">
      <PreviousPageButton
        :disabled="false"
        location-fallback-link="/personal_area"
      />
    </div>
    <TitleWithDatesFilter
      title="Аналитика рабочих смен"
      @on-save-dates="getUsers"
    />
    <Preloader v-if="isLoading" />
    <div v-else-if="users.length < 1" class="table_empty">
      <span>Рабочих смен для данного промежутка времени не найдено</span>
    </div>
    <div v-else>
      <div class="table-responsive">
        <table class="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th v-for="column in table.columnNames" :key="column" class="list__column">
                {{ column }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id" @click="goToUser(user)">
              <td class="list__row">
                {{ user.fullname }}
              </td>
              <td class="list__row">
                {{ user.role }}
              </td>
              <td class="list__row">
                {{ user.number_of_working_hours || 0 }}
              </td>
              <td class="list__row">
                <button
                  :class="getPseudoLinkCss(user, 'auto_ended_shifts')"
                  v-popover:shifts-popover
                  @click="showAutoEndedShifts(user)"
                >
                  {{ user.auto_ended_shifts.length }}
                </button>
              </td>
              <td class="list__row">
                <span
                  :class="getPseudoLinkCss(user, 'projects_in_work')"
                  @click.stop="toggleProjectsModal(user.projects_in_work)"
                >
                  {{ user.projects_in_work.length }}
                </span>
              </td>
              <td class="list__row">
                <span
                  :class="getPseudoLinkCss(user, 'with_failed_deadline')"
                  @click.stop="toggleProjectsModal(user.with_failed_deadline, true)"
                >
                  {{ user.with_failed_deadline.length }}
                </span>
              </td>
              <td class="list__row">
                <span
                  :class="getPseudoLinkCss(user, 'ended_products')"
                  @click.stop="toggleUserProductsModal(user.id)"
                >
                  {{ user.ended_products }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from "@/_shared/components/ui/Preloader";
import ItemsPopover from "@/_shared/components/ui/ItemsPopover";
import PreviousPageButton from "@/_shared/components/ui/PreviousPageButton";
import TitleWithDatesFilter from "@/user/features/personal-area/TitleWithDatesFilter";
import UserProjectsModal from "@/user/components/analytics/UserProjectsModal";
import UserProductsModal from "@/user/components/analytics/UserProductsModal";
import { analyticsService } from "@/_shared/api-services";
import { formats } from "@/_shared/constants";
import { lists } from "@/user/constants";
export default {
  components: {
    Preloader,
    ItemsPopover,
    PreviousPageButton,
    TitleWithDatesFilter,
    UserProjectsModal,
    UserProductsModal,
  },
  data() {
    return {
      dates: [],
      users: [],
      openedModals: {
        projects: {
          isVisible: false,
          list: [],
          withFailedDeadlines: false,
        },
        userProducts: {
          isVisible: false,
          userId: null,
        },
      },
      isLoading: false,
      showingAutoEndedShifts: [],
    };
  },
  computed: {
    table() {
      return lists.workAnalytics;
    },
  },
  methods: {
    showAutoEndedShifts(user = {}) {
      this.showingAutoEndedShifts = user.auto_ended_shifts.map((shift) => {
        const shiftDate = new Date(shift);
        return shiftDate.toLocaleString('ru', formats.dates.autoEndedShifts);
      });
    },
    toggleUserProductsModal(userId = null) {
      this.openedModals.userProducts = {
        isVisible: !this.openedModals.userProducts.isVisible,
        userId,
      };
    },
    toggleProjectsModal(list = [], withFailedDeadlines = false) {
      this.openedModals.projects = {
        isVisible: !this.openedModals.projects.isVisible,
        list,
        withFailedDeadlines,
      };
    },
    getPseudoLinkCss(user = {}, listName = '') {
      const list = user[listName];
      const listIsEmpty = !!(list === 0 || list.length === 0);
      const color = listName === 'with_failed_deadline' ? 'red' : 'blue';
      return {
        'row__pseudolink': !listIsEmpty,
        'row__pseudolink_disabled': listIsEmpty,
        [`row__pseudolink_${color}`]: !listIsEmpty,
      };
    },
    goToUser(user = {}) {
      const slug = `/users/${user.id}`;
      const route = this.$router.resolve(slug);
      window.open(route.href, "_blank");
    },
    async getUsers(dates = []) {
      this.isLoading = true;
      this.dates = dates;
      const [startDate, endDate] = dates;
      const params = {
        mode: 'all_users',
        from: startDate.toLocaleString('sv'),
        to: endDate.toLocaleString('sv'),
      };
      await analyticsService.getForWork(params).then(({ data }) => {
        this.users = data.records;
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
.prev-page-button__wrapper {
  padding-top: 2em;
}
.table_empty {
  text-align: center;
  padding-top: 30vh;
}
</style>



// WEBPACK FOOTER //
// src/user/pages/WorkAnalyticsPage.vue